<div class="avatar-card" [ngClass]="[!imageUrl ? 'image-empty' : '', size ? 'avatar-' + size : '']">
  @if (imageUrl) {
  <img [src]="imageUrl" [alt]="title" loading="lazy" width="60" height="60">
  } @else {
  <span class="avatar-icon k-d-flex">
    <img src="images/icon/avatar-empty-icon.svg" loading="lazy" alt="Avatar icon" width="33" height="33">
  </span>
  }
</div>
